import { render, staticRenderFns } from "./DiscountBanner.vue?vue&type=template&id=0a4c91e4&scoped=true&"
import script from "./DiscountBanner.vue?vue&type=script&lang=js&"
export * from "./DiscountBanner.vue?vue&type=script&lang=js&"
import style0 from "./DiscountBanner.vue?vue&type=style&index=0&id=0a4c91e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4c91e4",
  null
  
)

export default component.exports